/* Content remains visible without JS. Prices and purchase controls never animate. */
(() => {
  const body = document.body;
  if (body.classList.contains('gft-design-index')) {
    const updateHeader = () => body.classList.toggle('gft-has-scrolled', window.scrollY > 24);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const active = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      if (reduce.matches) return;
      const animation = target.animate([{ transform: 'translateY(16px)', opacity: 1 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 450, easing: 'ease-out' });
      active.add(animation);
      animation.finished.then(() => active.delete(animation)).catch(() => active.delete(animation));
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.gft-design-index #MainContent > .shopify-section > section').forEach(section => {
    if (section.matches('.ds-hero,.gft-selection,.ds-stimmen') || section.querySelector('product-form,.ds-pdp__rating,[data-needs-size],cart-drawer')) return;
    if (section.getBoundingClientRect().top >= window.innerHeight) observer.observe(section);
  });
  reduce.addEventListener('change', event => {
    if (!event.matches) return;
    observer.disconnect();
    active.forEach(animation => animation.cancel());
    active.clear();
  });
})();
